import React, { lazy, Suspense } from "react";

// react's lazy function only works with default exports, not with named exports, so the named
// CpIcon export has to be rewrapped as a default.
//
// Loading it lazily rather than synchronously also matters on the SystemJS path: the toast
// service is initialized early enough that canopy-styleguide is often not available yet, and
// SystemJS 0.21 fails to load the whole app on the circular reference between toast-service,
// canopy-styleguide, and the other util services.
//
// Keep the ESM_BUILD check inline rather than hoisting it to a variable. Webpack records
// external dependencies while parsing, so it only drops the unused branch if DefinePlugin can
// fold the test right here. Behind a variable, the AMD build gains a load-time dependency on
// understory and the deadlock above comes back.
const ActualCpIcon = lazy(() =>
  (process.env.ESM_BUILD === "true"
    ? import("@canopytax/understory")
    : SystemJS.import("canopy-styleguide!sofe")
  ).then((cs) => ({ default: cs.CpIcon })),
);

export default function CpIcon(props) {
  return (
    <Suspense fallback={null}>
      <ActualCpIcon {...props} />
    </Suspense>
  );
}
